import { ADD_USER_INFO, REMOVE_USER_INFO, AuthorizeAction, GET_FCM_TOKEN } from '../constants';

const initialState = {
  authorized: localStorage.getItem('authorized') || false,
  FCMToken: "",
};

export function userReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_USER_INFO:
      return {
        ...state,
        ...action.payload
      };
    case REMOVE_USER_INFO:
      return {};

    default:
      return state;
  }
};

export function authorizedReducer(state = initialState, action) {
  switch (action.type) {
    case AuthorizeAction.LOGIN_ACTION:
      return {
        ...state,
        authorized: true
      };

    case AuthorizeAction.LOGOUT_ACTION:
      return {
        ...state,
        authorized: false
      };

    case AuthorizeAction.LOGIN_3G_4G:
      return {
        ...state,
        isLogin3G: true
      };
    case GET_FCM_TOKEN:
      return {
        ...state,
        FCMToken: action.payload,
      };
    default:
      return state;
  }
}